import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function KeyExpansionsEmergingStrategicBets({
  keyExpansionsAndEmergingStrategicBets,
}) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     trending_industry_market: "b",
  //     expansion_type: "c",
  //     objective: "d",
  //     investment_impact: "e",
  //     status: "f",
  //     trending_industry_market_positive_insight: "b",
  //     trending_industry_market_negative_insight: "b",
  //     trending_industry_market_recent_development: "b",
  //     expansion_type_positive_insight: "c",
  //     expansion_type_negative_insight: "c",
  //     expansion_type_recent_development: "c",
  //     objective_positive_insight: "d",
  //     objective_negative_insight: "d",
  //     objective_recent_development: "d",
  //     investment_impact_positive_insight: "e",
  //     investment_impact_negative_insight: "e",
  //     investment_impact_recent_development: "e",
  //     status_positive_insight: "f",
  //     status_negative_insight: "f",
  //     status_recent_development: "f",
  //   },
  //   {
  //     competitor: "a",
  //     trending_industry_market: "b",
  //     expansion_type: "c",
  //     objective: "d",
  //     investment_impact: "e",
  //     status: "f",
  //     trending_industry_market_positive_insight: "b",
  //     trending_industry_market_negative_insight: "b",
  //     trending_industry_market_recent_development: "b",
  //     expansion_type_positive_insight: "c",
  //     expansion_type_negative_insight: "c",
  //     expansion_type_recent_development: "c",
  //     objective_positive_insight: "d",
  //     objective_negative_insight: "d",
  //     objective_recent_development: "d",
  //     investment_impact_positive_insight: "e",
  //     investment_impact_negative_insight: "e",
  //     investment_impact_recent_development: "e",
  //     status_positive_insight: "f",
  //     status_negative_insight: "f",
  //     status_recent_development: "f",
  //   },
  //   {
  //     competitor: "a",
  //     trending_industry_market: "b",
  //     expansion_type: "c",
  //     objective: "d",
  //     investment_impact: "e",
  //     status: "f",
  //     trending_industry_market_positive_insight: "b",
  //     trending_industry_market_negative_insight: "b",
  //     trending_industry_market_recent_development: "b",
  //     expansion_type_positive_insight: "c",
  //     expansion_type_negative_insight: "c",
  //     expansion_type_recent_development: "c",
  //     objective_positive_insight: "d",
  //     objective_negative_insight: "d",
  //     objective_recent_development: "d",
  //     investment_impact_positive_insight: "e",
  //     investment_impact_negative_insight: "e",
  //     investment_impact_recent_development: "e",
  //     status_positive_insight: "f",
  //     status_negative_insight: "f",
  //     status_recent_development: "f",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(
      keyExpansionsAndEmergingStrategicBets
    );
    setTabData(tableData);
  }, [keyExpansionsAndEmergingStrategicBets]);

  // Columns for GenericTable
  const tableColumns = [
    { key: "trending_industry_market", label: "Trending Industry Market" },
    { key: "expansion_type", label: "Expansion Type" },
    { key: "objective", label: "Objective" },
    { key: "investment_impact", label: "Investment Impact", width: "100px" },
    { key: "status", label: "Status" },
  ];

  return (
    <InsightTable
      title="Key Expansions & Emerging Strategic Bets"
      subtitle="Track competitor moves across trending industries — including major expansions and early-stage strategic bets — that shape market dynamics and signal future positioning."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default KeyExpansionsEmergingStrategicBets;
